import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIconEvent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#D04237"
      d="M4.967.73a.726.726 0 0 0-.726.726v1.065H3.25A2.662 2.662 0 0 0 .587 5.183v11.615A2.662 2.662 0 0 0 3.25 19.46h13.842a2.662 2.662 0 0 0 2.662-2.662V5.183A2.662 2.662 0 0 0 17.09 2.52h-.992V1.456a.726.726 0 0 0-.726-.726.75.75 0 0 0-.726.726v1.065H5.693V1.456A.75.75 0 0 0 4.967.73Zm12.124 17.278H3.249a1.21 1.21 0 0 1-1.21-1.21V8.183h16.262v8.615a1.21 1.21 0 0 1-1.21 1.21ZM14.647 3.973v.677a.726.726 0 0 0 .726.726.701.701 0 0 0 .726-.726v-.677h.992a1.21 1.21 0 0 1 1.21 1.21V6.73H2.039V5.183a1.21 1.21 0 0 1 1.21-1.21h.992v.677a.701.701 0 0 0 .726.726.726.726 0 0 0 .726-.726v-.677h8.954Z"
    />
    <path
      fill="#D04237"
      d="m13.292 10.434-4.163 3.654-1.766-1.79a.726.726 0 0 0-1.016 1.015l2.226 2.3a.75.75 0 0 0 .532.217.774.774 0 0 0 .484-.193l4.646-4.114a.726.726 0 1 0-.943-1.09Z"
    />
  </svg>
);
export default SvgIconEvent;
